import React from 'react';
import { handleScrollToTarget } from '../../utils/scrolling';
import { isNewGym } from '../../domain/IsNewGym/is-new-gym';

import { Stars } from '../Stars/Stars';
import { Gym, Swim, Class } from '../Icons';
import { LadiesOnly } from '../LadiesOnly/LadiesOnly';
import { Row, Column } from '@husslehq/ui-library';

import styles from '../../components/GymHeader/GymHeader.module.scss';

export interface Activity {
  name: string;
}

type Props = {
  address: string;
  name: string;
  numberOfReviews: number;
  score: number;
  activities: Activity[];
  ladiesOnly: boolean;
  dateLive: Date;
};

export const GymHeader: React.FC<Props> = ({
  address,
  name,
  numberOfReviews,
  score = 5,
  activities,
  ladiesOnly,
  dateLive,
}) => {
  const isNew = dateLive && isNewGym(dateLive);

  return (
    <div className={styles['gym-header']}>
      <Row>
        <Column xs="12" md="8">
          <h1 className={`${styles['gym-header__title']} ${isNew ? styles['gym-header__title--is-new'] : ''}`}>
            {name}
          </h1>
          <a className={styles['gym-header__address']} href="#gym-details-location" onClick={handleScrollToTarget}>
            {address}
          </a>
        </Column>
        {isNew && <p className={styles['gym-header__new']}>NEW</p>}
        <Column xs="12" md="4">
          <div className={styles['gym-header__rating']}>
            <a className={styles['gym-header__review-link']} href="#gym-details-reviews" onClick={handleScrollToTarget}>
              <span className={styles['gym-header__stars']}>
                <Stars value={score} size="smallest" />
              </span>
              <span className={styles['gym-header__avg-reviews']}>{score.toFixed(1)}</span>
              {numberOfReviews} reviews
            </a>
          </div>
          {activities.length > 0 && (
            <div className={styles['gym-header__activities']}>
              <span className={styles['gym-header__activities-title']}>Includes access to: </span>
              <ul className={`${styles['gym-header__activities-list']} list--unstyled`}>
                {activities.map((item, idx) => (
                  <li key={`activity_${idx}`} className={styles['gym-header__activities-list-item']}>
                    <span className={styles['gym-header__activities-list-icon']}>
                      {item.name === 'Gym' ? <Gym /> : item.name === 'Swim' ? <Swim /> : <Class />}
                    </span>
                    <span className={`${styles['gym-header__activities-list-name']} hidden-xs`}>{item.name}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </Column>
      </Row>
      {ladiesOnly && (
        <Row>
          <Column xs="12">
            <LadiesOnly />
          </Column>
        </Row>
      )}
    </div>
  );
};
